/* LOAD MORE for collection pages — click-to-load button (replaces silent auto-scroll). */
(function () {
  'use strict';
  const grid = document.getElementById('product-grid');
  const btn = document.getElementById('load-more-btn');
  if (!grid || !btn) return;

  let loading = false;

  function setLoading(isLoading) {
    loading = isLoading;
    btn.classList.toggle('is-loading', isLoading);
    btn.disabled = isLoading;
    const label = btn.querySelector('.load-more-btn__label');
    if (label) label.textContent = isLoading ? 'Loading...' : 'Load More Products';
  }

  function loadNext() {
    if (loading) return;
    const url = btn.getAttribute('data-next-url');
    if (!url) return;
    setLoading(true);
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.getElementById('product-grid');
        const newBtn = doc.getElementById('load-more-btn');
        if (newGrid) {
          Array.from(newGrid.children).forEach(function (child) {
            grid.appendChild(child);
          });
        }
        setLoading(false);
        if (newBtn && newBtn.getAttribute('data-next-url')) {
          btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
        } else {
          btn.remove();
        }
      })
      .catch(function (err) {
        console.error('Load more failed', err);
        setLoading(false);
      });
  }

  btn.addEventListener('click', function (e) {
    e.preventDefault();
    loadNext();
  });
})();
